import plus from './plus.png';
import minus from './minus.png';
import multiple from './multiple.png';
import divide from './divide.png';
import celcium from './celcium.png';
import cm from './cm.png';
import usd from './usd.png';
import eur from './eur.png';

export const images = {
  plus,
  minus,
  multiple,
  divide,
  celcium,
  cm,
  usd,
  eur
};
